import type { MessageKey } from './pt-BR';

/** Traduções em espanhol — mesmas chaves do pt-BR. */
export const es: Record<MessageKey, string> = {
  'nav.dashboard': 'Panel',
  'nav.animals': 'Animales',
  'nav.lots': 'Lotes',
  'nav.events': 'Eventos',
  'nav.movements': 'Movimientos',
  'nav.movements.short': 'Movim.',
  'nav.reproduction': 'Reproducción',
  'nav.reproduction.short': 'Repro.',
  'nav.indicators': 'Indicadores zootécnicos',
  'nav.indicators.short': 'Zootec.',
  'nav.dairy': 'Control lechero',
  'nav.dairy.short': 'Leche',
  'nav.sales': 'Ventas',
  'nav.sync_conflicts': 'Conflictos sync',
  'nav.sync_conflicts.short': 'Conflictos',
  'nav.admin': 'Administración',
  'nav.expand': 'Expandir menú lateral',
  'nav.collapse': 'Contraer menú lateral',
  'nav.brand.tagline': 'Gestión de ganado',
  'nav.footer': 'Sistema Manejai',

  'sex.male': 'Macho',
  'sex.female': 'Hembra',
  'event.weighing': 'Pesaje',
  'event.weaning': 'Destete',
  'event.natural_mount': 'Monta natural',
  'event.insemination': 'Inseminación',
  'event.pregnancy_diagnosis': 'Diagnóstico gestación',
  'event.birth': 'Parto',
  'event.milk_weighing': 'Pesaje leche',
  'event.medication': 'Medicación / Vacunación',
  'event.milestone': 'Hito',
  'movement.transfer': 'Transferencia',
  'movement.sale': 'Venta',
  'movement.death': 'Muerte',

  'event.detail.weight': 'Peso',
  'event.detail.weaning_weight': 'Peso destete',
  'event.detail.production': 'Producción',
  'event.detail.drying_off': 'Secado',
  'event.detail.bull': 'Toro',
  'event.detail.dose': 'Dosis',
  'event.detail.route': 'Vía',
  'event.detail.product_batch': 'Lote frasco',
  'event.detail.next_dose': 'Próxima dosis',
  'common.yes': 'Sí',
  'common.dash': '—',

  'settings.title': 'Mi cuenta',
  'settings.subtitle': 'Perfil, idioma, formatos y datos de la cuenta',
  'settings.tab.profile': 'Perfil',
  'settings.tab.locale': 'Idioma y región',
  'settings.tab.notifications': 'Notificaciones',
  'settings.tab.password': 'Contraseña',
  'settings.tab.client': 'Datos de la cuenta',
  'settings.locale.title': 'Idioma y región',
  'settings.locale.language': 'Idioma de la interfaz',
  'settings.locale.language_hint':
    'Al guardar, el menú y los textos conectados al idioma cambian automáticamente.',
  'settings.locale.formats_title': 'Formatos de la cuenta',
  'settings.locale.formats_hint':
    'Valen para todos los usuarios de esta cuenta. API y base siguen en kg y fechas ISO.',
  'settings.locale.country': 'País / región',
  'settings.locale.currency': 'Moneda',
  'settings.locale.weight_unit': 'Unidad de peso',
  'settings.locale.date_format': 'Formato de fecha',
  'settings.locale.time_format': 'Formato de hora',
  'settings.locale.timezone': 'Zona horaria',
  'settings.locale.formats_readonly':
    'Solo owner/manager puede cambiar los formatos de la cuenta. Puedes cambiar el idioma de la interfaz.',
  'settings.locale.saved': 'Preferencias actualizadas.',
  'settings.locale.language_saved': 'Idioma actualizado.',
  'settings.locale.save_error': 'Error al guardar.',
  'settings.locale.save': 'Guardar preferencias',
  'settings.locale.save_language': 'Guardar idioma',

  'locale.weight.kg': 'Kilogramo (kg)',
  'locale.weight.lb': 'Libra (lb)',
  'locale.date.dmy': 'Día / Mes / Año',
  'locale.date.mdy': 'Mes / Día / Año',
  'locale.date.ymd': 'Año - Mes - Día',
  'locale.time.h24': '24 horas',
  'locale.time.h12': '12 horas (AM/PM)',

  'calendar.open': 'Abrir calendario',
  'calendar.clear': 'Limpiar',
  'calendar.today': 'Hoy',
  'calendar.prev_month': 'Mes anterior',
  'calendar.next_month': 'Mes siguiente',
  'calendar.prev_year': 'Año anterior',
  'calendar.next_year': 'Año siguiente',

  'animal.access': 'Abrir animal',
  'common.options': 'Opciones',
};
